import { organisationConstants } from "../../_constants/organisation.constants";
import { dashBoardConstants } from "../../_constants/dashBoard.constants";
import { sellerConstants } from "../../_constants/seller.constants";
import { workSheetConstants } from "../../_constants/workSheet.constants";



const initialState = {
  loading: false,
  text: "",
  error: false,
  mainLoading: false,
};

function getErrorFunc(action) {
  let errorString = [];


  if (action.type === "RESPONSE_GROUP_MANDATE_UPDATE") {
    if (action.updated_mandate.data.message !== undefined) {
      errorString.push(action.updated_mandate.data.message);
      return errorString;
    }
  }

  if (action.type === "ERROR_REMOVE_ASSESSMENT") {
    if (action.error.response.data.message !== undefined) {
      errorString.push(action.error.response.data.message);
      return errorString;
    }
  }

  if (action.type === "ERROR_CREATE_WORKSHEET") {
    if (action.error.response.data.Error !== undefined) {
      errorString.push(action.error.response.data.Error);
      return errorString;
    }
  }

  if (action.type === "RECEIVE_SHARE_WORKSHEET") {
    let sharedStatus = action.shareWorksheet.data["Shared Status"];
    sharedStatus.map((val) => {
      let { email } = val;

      let errors = val.message !== undefined ? val.message : val.errors;
      errorString.push(`${email}: ${errors}`);
    });
    return errorString;
  }

  if (action.type === "RECEIVE_REMOVE_SHARING_WORKSHEET") {
    errorString.push(action.removeSharingWorksheet.data.message);
    return errorString;
  }

  if (action.type === "SHARE_WORKSHEET_ERROR") {
    if (action.meta === undefined) {
      let sharedStatus = action.error.response.data["Shared Status"];
      sharedStatus.map((val) => {
        let { email, errors } = val;
        errorString.push(`${email}: ${errors}`);
      });
      return errorString;
    } else {
      errorString.push(action.meta.closeModal);
      return errorString;
    }
  }

  if (action.type === "RECEIVE_UPDATE_WORKSHEET") {
    errorString.push(action.updateWorksheet.data.message);
    return errorString;
  }

  if (action.type === "RECEIVE_CREATE_WORKSHEET") {
    errorString.push(action.createWorksheet.createWorksheet.data.message);
    return errorString;
  }

  if (action.type === "ERROR_SET_EXPIRY") {
    errorString.push(action.error.response.data.message);
    return errorString;
  }

  if (action.type === "ERROR_SET_CUSTOM_REPORT") {
    if (action.error !== undefined) {
      if (action.error.response !== undefined) {
        if (action.error.response.data !== undefined) {
          if (action.error.response.data.message !== undefined) {
            errorString.push(action.error.response.data.message);
            return errorString;
          }
        }
      }
    }
  }

  if (action.sell_org_credits !== undefined) {
    if (action.sell_org_credits.data.message !== undefined) {
      errorString.push(action.sell_org_credits.data.message);
      return errorString;
    }
  }

  if (action.revoke_org_credits !== undefined) {
    if (action.revoke_org_credits.data.message !== undefined) {
      errorString.push(action.revoke_org_credits.data.message);
      return errorString;
    }
  }

  if (action.remove_analytics_org_admin !== undefined) {
    if (action.remove_analytics_org_admin.data.message !== undefined) {
      errorString.push(action.remove_analytics_org_admin.data.message);
      return errorString;
    }
  }

  if (action.add_analytics_org_admin !== undefined) {
    if (action.add_analytics_org_admin.data.message !== undefined) {
      errorString.push(action.add_analytics_org_admin.data.message);
      return errorString;
    }
  }

  if (action.allot_asse !== undefined) {
    if (action.allot_asse.data.message !== undefined) {
      errorString.push(action.allot_asse.data.message);
      return errorString;
    }
  }

  if (action.remove_from_batch !== undefined) {
    if (action.remove_from_batch.data.message !== undefined) {
      errorString.push(action.remove_from_batch.data.message);
      return errorString;
    }
  }

  if (action.set_custom_report !== undefined) {
    if (action.set_custom_report.data.message !== undefined) {
      errorString.push(action.set_custom_report.data.message);
      return errorString;
    }
  }

  if (action.set_dev_plan !== undefined) {
    if (action.set_dev_plan.data.message !== undefined) {
      errorString.push(action.set_dev_plan.data.message);
      return errorString;
    }
  }

  if (action.set_report_theme !== undefined) {
    if (action.set_report_theme.data.message !== undefined) {
      errorString.push(action.set_report_theme.data.message);
      return errorString;
    }
  }

  if (action.delete_report !== undefined) {
    if (action.delete_report.data.message !== undefined) {
      action.delete_report.data.message.map((val) => {
        errorString.push(val);
      });
      return errorString;
    }
  }

  if (action.disable_report !== undefined) {
    if (action.disable_report.data.message !== undefined) {
      errorString.push(action.disable_report.data.message);
      return errorString;
    }
  }

  if (action.enable_report !== undefined) {
    if (action.enable_report.data.message !== undefined) {
      errorString.push(action.enable_report.data.message);
      return errorString;
    }
  }

  if (action.unsub_assess !== undefined) {
    if (action.unsub_assess.data.message !== undefined) {
      action.unsub_assess.data.message.map((value) => {
        errorString.push(value.message);
      });
      
      return errorString;
    }
  }

  if (action.editOrgs !== undefined) {
    if (action.editOrgs.data.message !== undefined) {
      errorString.push(`Admin ${action.editOrgs.data.message}`);
      return errorString;
    }
  }

  if (action.edited !== undefined) {
    if (action.edited.status === 200) {
      errorString.push(`Organisation was Edited Successfully!`);
      return errorString;
    }
  }

  if (action.orgs !== undefined) {
    if (action.orgs.status === 201 || action.orgs.status === 200) {
      errorString.push(
        `${action.orgs.data.organisation_name} was Added Successfully with ${action.orgs.data.organisation_code} as the Organisation Code.`
      );
      return errorString;
    }
  }

 
  if (action.add_batch !== undefined) {
    if (action.add_batch.data.message !== undefined) {
      if (action.add_batch.data.message.non_field_errors !== undefined) {
        for (
          let i = 0;
          i < action.add_batch.data.message.non_field_errors.length;
          i++
        ) {
          const element = action.add_batch.data.message.non_field_errors[i];
          errorString.push(element);
        }
        return errorString;
      } else {
        errorString.push(`Batch ${action.add_batch.data.message}`);
        return errorString;
      }
    }
  }

  if (action.update_min_res !== undefined) {
    if (action.update_min_res.data.message !== undefined) {
      errorString.push(action.update_min_res.data.message);
      return errorString;
    }
  }

  //alloted and unalloted
  if (action.allot_batches !== undefined) {
    if (action.allot_batches.data.message !== undefined) {
      errorString.push(`Allotted Successfully`);
      return errorString;
    }
  }

  if (action.set_expiry !== undefined) {
    if (action.set_expiry.data.message !== undefined) {
      errorString.push(action.set_expiry.data.message);
      return errorString;
    }
  }

  //add participants
  if (action.add_par !== undefined) {
    action.add_par.data.message.map((value) => {
      errorString.push(value.message);
    });
    return errorString;
  }

  //invte

  if (action.invite_post !== undefined) {
    if (action.invite_post.data.message !== undefined) {
      action.invite_post.data.message.map((val) => {
        if (typeof val === "object") {
          if (val.success != undefined) {
            errorString.push(val.success);
          } else {
            for (const key in val) {
              if (val.hasOwnProperty(key)) {
             
                if (val[key].__all__ !== undefined) {
                  const element = `${key}: ${val[key].__all__[0]}`;
                  errorString.push(element);
                } else {
                  const element = `${key}: ${val[key]}`;
                  errorString.push(element);
                }
              }
            }
          }
        }
      });
      return errorString;
    }
  }

  //Remove Assessment
  if (action.remove_asessement !== undefined) {
    if (action.remove_asessement.data.message !== undefined) {
      errorString.push(action.remove_asessement.data.message);
      return errorString;
    }
  }

  //edit assessment

  if (action.edit_asessement !== undefined) {
    if (action.edit_asessement.data.message !== undefined) {
      errorString.push(action.edit_asessement.data.message);
      return errorString;
    }
  }

  //send remainder individual

  if (action.send_remainder_individual !== undefined) {
    if (action.send_remainder_individual.data.message !== undefined) {
      errorString.push(action.send_remainder_individual.data.message);
      return errorString;
    }
  }

  //send remainder bulk

  if (action.send_remainder_bulk !== undefined) {
    if (action.send_remainder_bulk.data.message !== undefined) {
      errorString.push(action.send_remainder_bulk.data.message);
      return errorString;
    }
  }

  //error org
  if (action.error !== undefined) {
    if (action.type === "ADD_MANAGE_METRIC_ERROR") {
      if (action.error.response.data.message.non_field_errors !== undefined) {
        for (
          let i = 0;
          i < action.error.response.data.message.non_field_errors.length;
          i++
        ) {
          const element =
            action.error.response.data.message.non_field_errors[i];
          errorString.push(element);
        }
        return errorString;
      } else {
        errorString.push("Error while Adding Competency!");
        return errorString;
      }
    }
    if (action.type === "UPDATE_MANAGE_METRIC_ERROR") {
      if (action.error.response.data.message.non_field_errors !== undefined) {
        for (
          let i = 0;
          i < action.error.response.data.message.non_field_errors.length;
          i++
        ) {
          const element =
            action.error.response.data.message.non_field_errors[i];
          errorString.push(element);
        }
        return errorString;
      } else {
        errorString.push("Error while Adding Competency!");
        return errorString;
      }
    } else if (action.error.response.data.message === undefined) {
      let keyObj = Object.keys(action.error.response.data);

      keyObj.map((value) => {
        action.error.response.data[value].map((val) => {
          let changedString = val.replace("This field", value);
          errorString.push(changedString);
        });
      });
      return errorString;
    } else {
      errorString.push(action.error.response.data.message);
     
      return errorString;
    }
  }
}

export function modalStatus(state = initialState, action) {
  switch (action.type) {
    //initialize
    case "INITIAL_IT":
     
      return {
        loading: false,
        text: "",
        error: false,
        mainLoading: false,
      };

    //Requests
    case "START_MODAL":
      return {
        loading: true,
        text: [],
        error: false,
        mainLoading: true,
      };

    //ADD COMPETENCY
    case organisationConstants.RECEIVE_ADD_MANAGE_METRIC:
      return {
        loading: false,
        text: ["Competency Successfully added"],
        error: false,
        mainLoading: true,
      };
    case organisationConstants.ADD_MANAGE_METRIC_ERROR:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //EDIT COMPETENCY
    case organisationConstants.RECEIVE_UPDATE_MANAGE_METRIC:
      return {
        loading: false,
        text: ["Competency Successfully Updated"],
        error: false,
        mainLoading: true,
      };
    case organisationConstants.UPDATE_MANAGE_METRIC_ERROR:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //SELLER CREDITS
    case sellerConstants.RECEIVE_SELL_CREDITS:
      return {
        loading: false,
        text: ["Credits Successfully Sold"],
        error: false,
        mainLoading: true,
      };
    case sellerConstants.SELL_CREDITS_ERROR:
      return {
        loading: false,
        text: ["Error while Selling Credits"],
        error: true,
        mainLoading: false,
      };

    case sellerConstants.RECEIVE_REVOKE_CREDITS:
      return {
        loading: false,
        text: ["Credits Successfully Revoked"],
        error: false,
        mainLoading: true,
      };
    case sellerConstants.REVOKE_CREDITS_ERROR:
      return {
        loading: false,
        text: ["Error while Revoking Credits"],
        error: true,
        mainLoading: false,
      };

    //DELETE COMPETENCY
    case organisationConstants.RECEIVE_DELETE_MANAGE_METRIC:
      return {
        loading: false,
        text: ["Competency Successfully Deleted!"],
        error: false,
        mainLoading: true,
      };
    case organisationConstants.DELETE_MANAGE_METRIC_ERROR:
      return {
        loading: false,
        text: ["Error while deleting Competency"],
        error: true,
        mainLoading: false,
      };

    //Responses
    case organisationConstants.RESPONSE_ADD_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.REQUEST_ERROR_ORG:

      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //Update Min Respondent

    //Responses
    case organisationConstants.RECEIVE_UPDATE_MIN_RES:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_EDIT_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_ADD_ADMIN_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_ADD_PARTICIPENTS:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_All_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_ENABLE_PI:
      return {
        loading: false,
        text: [action.enable_pi.data.message],
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_DISABLE_PI:
      return {
        loading: false,
        text: [action.disable_pi.data.message],
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RECIEVE_ADD_BATCH_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case organisationConstants.RESPONSE_BATCH_ADMIN_ORG:
      return {
        loading: false,
        text: [action.batchPerm.data.message],
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_UPDATE_MIN_RES:
      return {
        loading: false,
        text: [
          "Something went wrong while updating minimum Respondents, Please try again later!",
        ],
        error: true,
        mainLoading: false,
      };

    //Allot Batch

    //Responses
    case organisationConstants.RESPONSE_ALLOT_BATCH:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_ALLOT_BATCH:
      return {
        loading: false,
        text: ["Something went wrong while adding an Organisation"],
        error: true,
        mainLoading: false,
      };

    case organisationConstants.ERROR_EDIT_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_ADD_ADMIN_ORG:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_ADD_PARTICIPENTS:
      return {
        loading: false,
        text: [
          "Some error Occured while Adding Participants, Please try again later!",
        ],
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_All_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_ENABLE_PI:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_DISABLE_PI:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_ADD_BATCH_ORG:
      return {
        loading: false,
        text: [
          "Some error Occured while Adding Batch, Please try Again later!",
        ],
        error: true,
        mainLoading: false,
      };
    case organisationConstants.ERROR_BATCH_ADMIN_ORG:
      return {
        loading: false,
        text: [
          "Some error Occured while Committing for Batch Permissions, Please try Again later!",
        ],
        error: true,
        mainLoading: false,
      };

    case organisationConstants.RESPONSE_GROUP_MANDATE_UPDATE:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //Remove from batch

    //Responses
    case organisationConstants.RESPONSE_REMOVE_FROM_BATCH:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_REMOVE_FROM_BATCH:
      return {
        loading: false,
        text: [
          "Something went wrong while Removing Batch, Please try again later",
        ],
        error: true,
        mainLoading: false,
      };

    //Enable Report

    //Responses
    case organisationConstants.RESPONSE_ENABLE_REPORT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_ENABLE_REPORT:
      return {
        loading: false,
        text: ["Something went wrong while Enabling Report, Please try Again!"],
        error: true,
        mainLoading: false,
      };

    //DEV PLAN
    case organisationConstants.RESPONSE_SET_DEV_PLAN:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_SET_DEV_PLAN:
      return {
        loading: false,
        text: [
          "Something went wrong while setting up development Plan, Please try Again!",
        ],
        error: true,
        mainLoading: false,
      };

    //SET REPORT ACCESS
    case organisationConstants.RESPONSE_SET_CUSTOM_REPORT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_SET_CUSTOM_REPORT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //Disable Report

    //Responses
    case organisationConstants.RESPONSE_DISABLE_REPORT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_DISABLE_REPORT:
      return {
        loading: false,
        text: [
          "Something went wrong while Disabling Report, Please try Again!",
        ],
        error: true,
        mainLoading: false,
      };

    //Set Expiry Report

    //Responses
    case organisationConstants.RESPONSE_SET_EXPIRY:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_SET_EXPIRY:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //Set Theme report

    //Responses
    case organisationConstants.RESPONSE_SET_REPORT_THEME:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_SET_REPORT_THEME:
      return {
        loading: false,
        text: [
          "Something went wrong While Setting Report Theme, Please try again!",
        ],
        error: true,
        mainLoading: false,
      };

    //Delete report/Assessment

    //Responses
    case organisationConstants.RESPONSE_DELETE_REPORT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_DELETE_REPORT:
      return {
        loading: false,
        text: ["Something went wrong While Deleting Assessment!"],
        error: true,
        mainLoading: false,
      };

    //Unsubmit Assessment

    //Responses
    case organisationConstants.RESPONSE_UNSUBMITTED_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case organisationConstants.ERROR_UNSUBMITTED_ASSESSMENT:
      return {
        loading: false,
        //    ['Something went wrong while Un-Submitting Assessment']
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    ///Dash Board
    //Invite
    //Responses
    case dashBoardConstants.RECIEVE_INVITE_POST:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case dashBoardConstants.ERROR_INVITE_POST:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //edit assessment
    case dashBoardConstants.RECIEVE_EDTI_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case dashBoardConstants.ERROR_EDTI_ASSESSMENT:
      return {
        loading: false,
        text: ["Something went wrong"],
        error: true,
        mainLoading: false,
      };

    //Remove Assessment
    case dashBoardConstants.RECIEVE_REMOVE_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case dashBoardConstants.ERROR_REMOVE_ASSESSMENT:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //Send remainder ind
    case dashBoardConstants.RECIEVE_SEND_REMAINDER_INDIVIDUAL:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case dashBoardConstants.ERROR_SEND_REMAINDER_INDIVIDUAL:
      return {
        loading: false,
        text: ["Something went wrong"],
        error: true,
        mainLoading: false,
      };

    //Send remainder bulk
    case dashBoardConstants.RECIEVE_SEND_REMAINDER_BULK:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    //Errors
    case dashBoardConstants.ERROR_SEND_REMAINDER_BULK:
      return {
        loading: false,
        text: ["Something went wrong"],
        error: true,
        mainLoading: false,
      };

    //Add Individual Analytics
    case organisationConstants.RESPONSE_ADD_ANALYTICS_ORG_ADMIN:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    case organisationConstants.ERROR_ADD_ANALYTICS_ORG_ADMIN:
      return {
        loading: false,
        text: ["Something went wrong while adding analytics!"],
        error: true,
        mainLoading: false,
      };

    case organisationConstants.RESPONSE_REMOVE_ANALYTICS_ORG_ADMIN:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    case organisationConstants.ERROR_REMOVE_ANALYTICS_ORG_ADMIN:
      return {
        loading: false,
        text: ["Something went wrong while adding analytics!"],
        error: true,
        mainLoading: false,
      };

    case organisationConstants.RESPONSE_SELL_ORG_CREDITS:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    case organisationConstants.ERROR_SELL_ORG_CREDITS:
      return {
        loading: false,
        text:
          action.error.response.status === 400
            ? [action.error.response.data.message]
            : ["Something went wrong while Selling Organisation Credits!"],
        error: true,
        mainLoading: false,
      };

    case organisationConstants.RESPONSE_REVOKE_ORG_CREDITS:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };

    case organisationConstants.ERROR_REVOKE_ORG_CREDITS:
      return {
        loading: false,
        text: ["Something went wrong while Revoking Organisation Credits"],
        error: true,
        mainLoading: false,
      };

    //create worksheet
    case workSheetConstants.RECEIVE_CREATE_WORKSHEET:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case workSheetConstants.ERROR_CREATE_WORKSHEET:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //edit worksheet
    case workSheetConstants.RECEIVE_UPDATE_WORKSHEET:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case workSheetConstants.UPDATE_WORKSHEET_ERROR:
      return {
        loading: false,
        text: ["Something went wrong while updating "],
        error: true,
        mainLoading: false,
      };

    //share worksheet
    case workSheetConstants.RECEIVE_SHARE_WORKSHEET:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case workSheetConstants.SHARE_WORKSHEET_ERROR:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: true,
        mainLoading: false,
      };

    //remove worksheet
    case workSheetConstants.RECEIVE_REMOVE_SHARING_WORKSHEET:
      return {
        loading: false,
        text: getErrorFunc(action),
        error: false,
        mainLoading: true,
      };
    case workSheetConstants.REMOVE_SHARING_WORKSHEET_ERROR:
      return {
        loading: false,
        text: ["Something went wrong while Removing!"],
        error: true,
        mainLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/modalStatus.reducer.js